import {useMemo} from 'react'
import {useSelector} from 'react-redux'
import {getHotel, State} from 'modules/sapiSearch/selectors'

import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'

import {isSupportedTheme} from './themes'
import {PropertyHighlight} from './types'

export const PROPERTY_HIGHLIGHTS_EXPERIMENT_ID =
  'dcbc5616-property-highlights-v1'

export const selectDisplayedHighlights = (highlights?: PropertyHighlight[]) => {
  const supported = (highlights ?? []).filter(isSupportedTheme)
  const location = supported
    .filter(({theme}) => theme === 'location')
    .slice(0, 1)
  const themes = supported.filter(({theme}) => theme !== 'location').slice(0, 2)

  return {
    location,
    themes,
    displayed: [...location, ...themes]
  }
}

/** The `custom_event_payload.highlights` of `vio/property-highlights/experiment-v1-tracking`. */
export const getPropertyHighlightsAnalyticsPayload = (
  highlights?: PropertyHighlight[]
): {highlights?: string[]} => {
  const themes = selectDisplayedHighlights(highlights).displayed.map(
    ({theme}) => theme
  )

  return themes.length > 0 ? {highlights: themes} : {}
}

export const useServedHighlights = (
  hotelId?: string
): PropertyHighlight[] | undefined => {
  const toggle = useToggle()
  const hotel = useSelector((state: State) => getHotel(state, hotelId))

  if (!hotelId || !toggle(PROPERTY_HIGHLIGHTS_EXPERIMENT_ID, false, true))
    return undefined

  return hotel?.highlights
}

export const usePropertyHighlights = (hotelId?: string) => {
  const {location, themes} = selectDisplayedHighlights(
    useServedHighlights(hotelId)
  )

  return {location, themes, show: location.length + themes.length > 0}
}

export const usePropertyHighlightsAnalyticsPayload = (hotelId?: string) => {
  const highlights = useServedHighlights(hotelId)

  return useMemo(
    () => getPropertyHighlightsAnalyticsPayload(highlights),
    [highlights]
  )
}
